export enum ProductType {
    Naturpool = 'naturpool',
    Biopool = 'biopool',
    Schwimmteich = 'schwimmteich',
}
